import { activeNavKey } from '@/viewmodel/shared/sidebar/mappers/navItems';
import type { NavItem, SideBarNavViewState } from '@/viewmodel/shared/sidebar/types';
import { useLocation, useNavigate } from 'react-router-dom';

export function useSideBarNavViewModel(items: readonly NavItem[]): SideBarNavViewState {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeKey = activeNavKey(items, pathname);

  return {
    activeKey,
    activeLabel: items.find((item) => item.key === activeKey)?.label,
    open: (item) => {
      if (item.path) navigate(item.path);
    },
  };
}
